module.exports = __webpack_public_path__ + "img/va.abc90cba.svg";